import React, { Component, PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Map, List, fromJS } from 'immutable'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox, Popup } from 'semantic-ui-react'
import { updateInterview, deleteInterview, deliverInterview } from '../../actions'
import { InlineInput } from '~/form'
import InterviewStatus from '~/interview/status'

import Tasks from './tasks'
import ContentInfo from './contentInfo'
import { InterviewProducts } from './products'
import InterviewDetails from './interview/details'
import Notes from './notes'

const INTERVIEW_TASK_TYPE_ID = 'INTERVIEW'

// <ContentInfo interview={ interview }
//   updateInterview={ values => updateInterview(project.get('id'), interview.get('id'), values) } />
// <Notes interview={ interview } />

function DeletePrompt({ onAnswer }) {
  let deleteTrigger = <span className="button-plain">Poista haastattelu</span>

  let deleteContent = (
    <div className="prompt">
      <b>Oletko varma?</b>
      <div className="prompt-button">
        <Button size="tiny" content="Kyllä" onClick={e => e.preventDefault() & onAnswer(true)} color="red" />
      </div>
    </div>
  )

  return <Popup trigger={deleteTrigger} content={deleteContent} on="click" position="top right" />
}

function DeliverPrompt({ onAnswer, delivered }) {
  let deleteTrigger = (
    <Button
      size="tiny"
      content={!delivered ? 'Näytä aineistot asiakkaan dashboardilla' : 'Poista aineistot asiakkaan dashboardilta'}
      onClick={e => e.preventDefault()}
      color={!delivered ? 'green' : 'red'}
    />
  )

  let deleteContent = (
    <div className="prompt">
      <b>Oletko varma?</b>
      <div className="prompt-button">
        <Button
          size="tiny"
          content="Kyllä"
          onClick={e => e.preventDefault() & onAnswer(true)}
          color={!delivered ? 'green' : 'red'}
        />
      </div>
    </div>
  )

  return <Popup trigger={deleteTrigger} content={deleteContent} on="click" position="top right" />
}

class Interview extends Component {
  render() {
    let { interviews = List(), project, productsById, dispatch, match } = this.props
    let {
      params: { interview_id },
    } = match

    let interview = interviews.find(i => i.get('id') === interview_id)

    if (!Map.isMap(interview)) interview = Map()

    let tasks = interview.get('tasks', List())

    let interviewMainTask = tasks.filter(t => t.get('task_type_id') === INTERVIEW_TASK_TYPE_ID)
    let delivered = interview.getIn(['data', 'delivered'], false)

    return (
      <Fragment>
        <div className="subeditor-header subeditor-header--flex">
          <div className="subeditor-header-left">
            <InlineInput
              value={interview.get('name')}
              title
              onUpdate={value => {
                let events = [
                  {
                    type: 'INTERVIEW_CHANGE_NAME',
                    variables: {
                      old_name: interview.get('name'),
                      updated_name: value,
                    },
                  },
                ]

                dispatch(
                  updateInterview(
                    project.get('id'),
                    interview.get('id'),
                    interview.set('name', value).setIn(['data', 'disable_auto_name'], true),
                    events
                  )
                )
              }}
            />
          </div>
          <div className="subeditor-header-right">
            <InterviewStatus interview={interview} />
          </div>
        </div>
        <div className="subeditor-container">
          <Tasks project={project} interview={interview} />
          <InterviewDetails
            interview={interview}
            project={project}
            interviews={interviews}
            mainTask={interviewMainTask}
            updateActiveInterview={(interview, events = []) =>
              dispatch(updateInterview(project.get('id'), interview.get('id'), interview, events))
            }
          />
          <InterviewProducts interview={interview} productsById={productsById} project={project} />
          <div className="subeditor-footer">
            <div className="subeditor-footer-left">
              <DeliverPrompt
                delivered={delivered}
                onAnswer={doIt => (doIt ? dispatch(deliverInterview(project.get('id'), interview.get('id'))) : null)}
              />
            </div>
            <div className="subeditor-footer-right">
              <DeletePrompt
                onAnswer={doIt => (doIt ? dispatch(deleteInterview(project.get('id'), interview.get('id'))) : null)}
              />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(
  connect(state => ({
    project: state.activeProject,
  }))(Interview)
)
